/* global GLOBALS */
import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import AccountProfile from 'models/account_profile';


/* This view is used to display a message at the top of the track page */

export default Backbone.View.extend({
  initialize: function (options) {
    _.bindAll.apply(_, [this].concat(_.functions(this)));

    // Two possible tip types at the moment: assessment or notification
    this.templates = {
      assessmentTip: _.template(require('html-loader!js/assessment-tip.html')),
      notifTip: _.template(require('html-loader!js/notification-tip.html')),
    };

    this.assessmentViews = options.assessmentViews;

    // Once the account profile is loaded, we can render
    this.accountProfile = new AccountProfile();
    $.when(this.accountProfile.fetch({ cache: false })).then(this.render);
  },

  needsScreener: function (slug) {
    const cc = slug.replace(/-([a-z])/g, function (match) {
      return match[1].toUpperCase();
    });
    const needsFuncName = `needs${cc.charAt(0).toUpperCase()}${cc.slice(1)}`;
    if (this[needsFuncName]) {
      return this[needsFuncName]();
    }
    const assessmentView = this.assessmentViews[slug];
    return assessmentView.model.get('screener').days_until_due === 0;
  },

  hide: function () {
    // Clear any existing message
    $('.mh-alert', this.el).remove();
    this.trigger('notified');
  },

  render: function () {
    var tips = [];

    // Do they need a notification tip?
    if (!GLOBALS.IS_PHONE_VERIFIED && !GLOBALS.HAS_MOBILE) {
      tips.push({ type: 'notification' });
    }

    // Do they need tips for any screeners?
    _.each(_.keys(this.assessmentViews), function (slug) {
      if (this.needsScreener(slug)) {
        tips.push({ type: 'screener', slug: slug });
      }
    }, this);

    // If none of the tips are needed, hide it and return
    if (tips.length === 0) {
      this.hide();
      return;
    }

    // Render the appropriate tip
    var daysSince = this.accountProfile.days_since_joined() || 0;
    var alternate = daysSince % tips.length;
    this.showTip(tips[alternate]);

    // Make sure to prevent default on modal links
    $('a[data-toggle="modal"]', this.el).on('click', function (ev) {
      ev.preventDefault();
    });
    this.trigger('notified');
  },

  needsDayToDayWellBeing: function () {
    /* Show every 30 days until taken
          1. A MoodHacker tip appears, inviting the user to take the Well-Being
             assessment when the user first creates an account.
          2. A MoodHacker tip appears, inviting the user to take the Well-Being
             assessment 30 days after sign up.
          3. A MoodHacker tip appears, inviting the user to take the Well-Being
             assessment 60 days after sign up.
          4. A MoodHacker tip appears, inviting the user to take the Well-Being
             assessment 90 days after sign up.
          5. The tip continues to appear until the user takes the assessment.
          NOTE from Amy: Sara and I see no problem with the tips continuing
          past 90 days
    */
    var daysSinceJoined = this.accountProfile.days_since_joined();
    var screener = this.assessmentViews['day-to-day-well-being'].model
      .get('screener');
    var daysTilDue = screener.days_since_taken ?
      screener.due_every - screener.days_since_taken : 0;
    return daysSinceJoined % 30 + daysTilDue < 30;
  },

  showTip: function (tip) {
    if (tip.type === 'screener') {
      this.$el.prepend(this.templates.assessmentTip({
        screenerSetItem: this.assessmentViews[tip.slug].model
      }));

      // When the screener is complete, hide the tip
      this.assessmentViews[tip.slug].on('screener-results', this.hide);
    } else if (tip.type === 'notification') {
      this.$el.prepend(this.templates.notifTip());
    }
  }
});



// WEBPACK FOOTER //
// ./static/js/views/message.js